import React, { Component } from 'react';
import connect from "react-redux/es/connect/connect";
import ProfilesList from "../components/profileslist";
import ProfilesFilter from "../components/profilesfilter";
import * as wConsts from "../consts/website-consts";
import NotFound from "../components/notfound";

class Home extends Component {

  componentDidMount() {
    this.props.dispatch({ type: wConsts.ACTION_SET_PAGETYPE, payload: "home" });
    
  }
  render() {

    if(this.props.WebPage.PageLoaded && this.props.WebPage.Page.Name === "404") {
      return <NotFound />;
    }

    return (
      <div className="container">
        <ProfilesFilter filters={this.props.WebPage.Menu.Filter[0].Menu} pos={"top"} />
        <ProfilesList pageType={this.props.pageType} />
        <ProfilesFilter filters={this.props.WebPage.Menu.Filter[0].Menu} pos={"bottom"} />
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    SelectedLocal: state.Website.Settings.SelectedLocal,
    ProfilePath: state.Website.ProfilePath,
    WebPage: state.Website
  };
};

export default connect(mapStateToProps)(Home);
